export default ['AxaRightsAllocation'];
